import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export default function Loader() {
    const { t } = useLang();
    // phases: "show" -> "exit" (slide up) -> "gone" (unmount)
    const [phase, setPhase] = useState("show");

    useEffect(() => {
        const t1 = setTimeout(() => setPhase("exit"), 1900);
        const t2 = setTimeout(() => setPhase("gone"), 2800);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        };
    }, []);

    if (phase === "gone") return null;

    return (
        <motion.div
            data-testid="site-loader"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-cb-darker cb-grid"
            initial={{ y: "0%" }}
            animate={{ y: phase === "exit" ? "-100%" : "0%" }}
            transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        >
            <div className="overflow-hidden">
                <motion.div
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="font-display text-5xl md:text-7xl font-bold tracking-tighter text-white"
                >
                    Gruppo <span className="text-cb-accent">CB</span> Srl
                </motion.div>
            </div>
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
                className="mt-4 text-sm uppercase tracking-[0.3em] text-slate-400"
            >
                {t.loader}
            </motion.p>
            <motion.div
                className="mt-8 h-[2px] bg-cb-accent"
                initial={{ width: 0 }}
                animate={{ width: 220 }}
                transition={{ duration: 1.6, ease: "easeInOut" }}
            />
        </motion.div>
    );
}
